import React from "react";
import i18n from '../../../i18n';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {withStyles} from "@material-ui/core";
import TableRowCollapse from "./TableRowCollapse";

const ContractBuildingsTable = (props) => {
    const {
        contract,
        detail,
        classes,
    } = props;

    const buildings = contract.buildings || null;

    return (
        <React.Fragment>
            <Table className={classes.list}>
                <TableHead>
                    <TableRow>
                        {detail && (
                            <TableCell align={'center'} style={{width:120}}>
                                {i18n.get('deficiency.self_open')}
                            </TableCell>
                        )}
                        <TableCell>
                            {i18n.get('building.house')}
                        </TableCell>
                        <TableCell>
                            {i18n.get('building.address')}
                        </TableCell>
                        <TableCell align="center">{i18n.get('building.actions.self')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { buildings && buildings.map( (contractBuilding) =>
                        <TableRowCollapse key={`building_${contractBuilding.building.id}`} values={contractBuilding.building} detail={detail} />
                     ) }
                </TableBody>
            </Table>
        </React.Fragment>
    )
};

const styles = theme => ({
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        },
    },
});

export default withStyles(styles)(ContractBuildingsTable);
